module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAJFBMVEXgUgb////53s/kZyTvpX798+776uHjYBv308Dvo3vnekANsCuUC0HdAAAAhUlEQVR4Ae3UNwECYRBE4dmKktCBCizgAAlY+R3RI46cyn2Xw7z+u3wj55xzbiCtaasmyYaSvSQdCNGryJOj3uWJPkWWnPQtS/QrcmSlXwtOlCP6r3ASwyFbTnadnGU9DlL4N9bal8z/F/5X8n+fLwzfMbiWYJNB1cmFdm6DmJiYmJiY3ABbwxA2mht0lQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Niger.png
// module id = 603
// module chunks = 0